import { AccountTotals } from 'core/cuenta/models/AccountTotals';
import { useCoreService } from 'core/services/useCoreService';
import { Periodo } from 'shared/models/Periodo';
import { withPagination } from 'shared/table/hoc/withPagination';
import { Pageable } from 'shared/table/models/Pageable';
import { AccountsTotalsTable } from '../AccountsTotalsTable/AccountsTotalsTable';

const TableWithPagination = withPagination<AccountTotals>(AccountsTotalsTable);

export const AccountsTotalsTableWithPagination = (props: {
  cuentas: Pageable<AccountTotals>;
  totals: AccountTotals;
  periodo: Periodo;
}) => {
  const coreService = useCoreService();

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<AccountTotals>> => {
    const response = await coreService.searchAccountsTotals({
      page: status.pageNumber,
      size: status.pageSize,
    });
    return response.body;
  };

  return (
    <TableWithPagination
      pageableInit={props.cuentas}
      totals={props.totals}
      periodo={props.periodo}
      dataFetcherFunction={onChangePaginationStatus}
    ></TableWithPagination>
  );
};
